import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import { SortByDesktop } from 'components/SortBy';
import { TotalPriceToggle } from 'components/TotalPriceToggle/TotalPriceToggle';
import { getIsSearchHasResults, getIsSearchPending } from 'modules/sapiSearch/selectors';
import { useDeviceLayout } from '@daedalus/atlas/context/deviceLayout';
import { Flex } from '@daedalus/atlas/helpers/Flex';
import { SkeletonLoader } from '@daedalus/atlas/SkeletonLoader';
import { useBrand } from '@daedalus/core/src/_web/brand/hooks/useBrand';
const _exp = /*#__PURE__*/() => Flex.Row;
const Wrapper = /*#__PURE__*/styled(_exp())({
  name: "Wrapper",
  class: "w4qgfry",
  propsAsIs: true
});
export const SearchResultsControls = () => {
  const {
    isMobile
  } = useDeviceLayout();
  const {
    brandHasSort
  } = useBrand();
  const isSearchHasResults = useSelector(getIsSearchHasResults);
  const isLoading = useSelector(getIsSearchPending);
  const isSearchLoading = isLoading && !isSearchHasResults;
  if (isMobile) {
    return <TotalPriceToggle />;
  }
  if (isSearchLoading) return <Wrapper alignItems="center" justifyContent="space-between">
        <SkeletonLoader height={30} width={110} />
        <SkeletonLoader height={30} width={160} marginTop={0} />
      </Wrapper>;
  return <Wrapper alignItems="center" justifyContent="space-between">
      {brandHasSort && <SortByDesktop />}
      <TotalPriceToggle />
    </Wrapper>;
};

require("./SearchResultsControls.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./SearchResultsControls.tsx");